export default __webpack_public_path__ + "static/media/search-bar-empty-error.6d53c7f5.svg";